import './Emphasis.css';
export var emphasisCSS = '_1r35rtu0-3-8-0';